module.exports = __webpack_public_path__ + "img/car_icon18.43173da3.png";